import React, { useEffect, useState, useContext } from "react";
import { motion } from "framer-motion";
import { FaSearch, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Stalls.css";
import { KioskAuthContext } from "../../../ContextAPI/KisokContext";

export default function Stalls() {
  const navigate = useNavigate();
  const { kioskUser } = useContext(KioskAuthContext);

  const ownerId = kioskUser?.owner_id;

   const [stalls, setStalls] = useState([]);
  const [search, setSearch] = useState("");

// Clear cart on entry
useEffect(() => {
  console.log("🧹 Clearing cart and menu items on Stalls page load");
  localStorage.removeItem("fliplyn_cart");
  localStorage.removeItem("fliplyn_stall_session");
  localStorage.removeItem("menuItemsList");
}, []);

// Auto-navigate after 2 minutes
useEffect(() => {
  const timer = setTimeout(() => {
    console.log("⏱ 2 minutes passed, navigating to /stalls-user");
    navigate("/stalls-user");
  }, 2 * 60 * 1000);

  return () => clearTimeout(timer);
}, [navigate]);


  // Directly fetch stalls — no caching
  useEffect(() => {
    if (!ownerId) return;

    const fetchStalls = async () => {
      try {
        const response = await axios.get(
          `https://fliplyn-b-c.fly.dev/stalls/owner/${ownerId}`
        );
        setStalls(response.data);
      } catch (error) {
        console.error("Error fetching stalls:", error);
      }
    };

    fetchStalls();
  }, [ownerId]);

  const filteredStalls = stalls.filter((stall) =>
    stall.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleStallClick = (stall) => {
    navigate(`/menu`, {
      state: {
        stallId: stall.id,
        stall,
      },
    });
  };

  return (
    <div className="stalls-page-container">
      <button className="back-btn" onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>

      <motion.div
        className="top-section-test"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="page-title">Find Your Feast</h1>
        <p className="page-subtitle">Select a Stall to Begin Your Order.</p>

        <div className="search-bar-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search Stalls"
            className="search-bar"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </motion.div>

      <motion.div
        className="bottom-section"
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, delay: 0.2 }}
      >
        <div className="stalls-grid">
          {filteredStalls.length > 0 ? (
            filteredStalls.map((stall, index) => (
              <motion.div
                key={stall.id}
                className="stall-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 + index * 0.05, duration: 0.4 }}
                onClick={() => handleStallClick(stall)}
              >
                <div className="stall-image-container">
  <img
    src={stall.image_url}
    alt={stall.name}
    className="stall-image"
  />
</div>
                <p className="stall-name">{stall.name}</p>
              </motion.div>
            ))
          ) : (
            <p className="no-stalls">No stalls found.</p>
          )}
        </div>
      </motion.div>
    </div>
  );
}
